import React, { useState } from 'react';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import { BiCopy } from 'react-icons/bi';
import './ManagerMobile.css';

function DashboardNavbar({ buildingId, buildingName, contractLabel, logoutInSidebar = false }) {
  const [showCopied, setShowCopied] = useState(false);

  // unit-access asks for the Issue Number off the yellow notice instead of a
  // unit number, so a resident can only open their own suite. No type param:
  // paper-login returns the maintenance type and the page routes on that, which
  // also means a dryer building stops depending on the link being built right.
  const portalLink = `https://hudsonhvac.ca/unit-access?id=${buildingId || ''}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(portalLink)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      })
      .catch((err) => console.error("Copy failed:", err));
  };

  const handleLogout = () => {
    localStorage.removeItem('managerToken');
    localStorage.removeItem('managerUser');
    localStorage.removeItem('hasDoneInitialRedirect'); // Clear redirect flag
    window.location.href = '/login';
  };

  return (
    <div className="navbar-dark-bg manager-navbar" style={{ position: 'relative' }}>
      {showCopied && (
        <Alert
          variant="success"
          style={{
            position: 'absolute',
            top: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            margin: 0,
            padding: '0.5rem 1rem'
          }}
        >
          <strong>Link copied to clipboard!</strong>
        </Alert>
      )}

      <Container fluid>
        <Row className="align-items-center navbar-top-row">
          {/* LEFT: two-line Building info */}
          <Col className="navbar-left-col" xs="auto">
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              {/* Company Name */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="navbar-building-label">{contractLabel || 'Building'}</div>
                <h2 className="navbar-building-title">{buildingName}</h2>
              </div>
              
              {/* Company Logo - Only show for corporate dashboard pages */}
              {buildingName && (buildingName === 'BMI Overview' || buildingName === 'Hudson Overview') && (
                <img 
                  src={buildingName.includes('BMI')
                    ? '/bmi-logo.png'
                    : 'https://hudsonhvac.ca/images/sq.png'
                  }
                  alt={`${buildingName} Logo`}
                  style={{ 
                    height: '40px', 
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              )}
            </div>
          </Col>

          {/* RIGHT: portal link, copy, logout */}
          <Col className="manager-navbar-actions d-flex align-items-center justify-content-end">
            {/* Resident Portal Link */}
            {(contractLabel === 'In-Suite Preventive Maintenance' || contractLabel === 'Dryer Vent Cleaning') && (
              <>
                <Button
                  variant="link"
                  className="manager-portal-link"
                  style={{
                    textDecoration: 'none',
                    color: '#fff',
                    fontSize: '1rem',
                    padding: 0,
                    marginRight: '1rem'
                  }}
                  onClick={() => window.open(portalLink, '_blank')}
                >
                  <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
                    Resident Portal Link
                  </span>
                </Button>

                {/* Copy icon */}
                <Button
                  variant="link"
                  style={{ textDecoration: 'none', color: '#fff', padding: 0, marginRight: logoutInSidebar ? 0 : '1.5rem' }}
                  onClick={copyToClipboard}
                  className="manager-portal-copy"
                  aria-label="Copy resident portal link"
                >
                  <BiCopy style={{ fontSize: '1.3rem' }} />
                </Button>
              </>
            )}

            {/* Logout */}
            {!logoutInSidebar && <Button
              variant="light"
              className="logout-button"
              onClick={handleLogout}
            >
              Logout
            </Button>}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DashboardNavbar;
